import { SiteRecceStatusEnum } from '@api/enum';
import { deleteSiteRecceRemark, updateSiteRecceRemarks } from '@api/services/site-recce.service';
import { useMutation } from '@tanstack/react-query';

const useRemarksUpdateSiteRecce = (
    clientInstallationId: string,
    projectInstallationId: string,
    siteRecceId: string
) => {
    // Separate cancel mutation
    const cancelMutation = useMutation((reason?: string) => {
        const cancelPayload = {
            status: SiteRecceStatusEnum.REJECTED,
            remarks: reason ?? '',
        };
        return updateSiteRecceRemarks(clientInstallationId, projectInstallationId, siteRecceId, cancelPayload);
    });

    // Separate complete mutation
    const completeMutation = useMutation((remarks?: string) => {
        const completePayload = {
            status: SiteRecceStatusEnum.COMPLETED,
            remarks: remarks ?? '',
        };
        return updateSiteRecceRemarks(clientInstallationId, projectInstallationId, siteRecceId, completePayload);
    });

    // Add Remarks
    const addRemarksMutation = useMutation((remarks?: string) => {
        const remarksPayload = {
            remarks: remarks ?? '',
        };
        return updateSiteRecceRemarks(clientInstallationId, projectInstallationId, siteRecceId, remarksPayload);
    });

    const cancelRecce = async (reason?: string) => {
        const data = await cancelMutation.mutateAsync(reason);
        return data;
    };

    const completeRecce = async (completionRemarks?: string) => {
        const data = await completeMutation.mutateAsync(completionRemarks);
        return data;
    };
    const addRemarks = async (remarks?: string) => {
        const data = await addRemarksMutation.mutateAsync(remarks);
        return data;
    };

    const removeRemarkMutation = useMutation((remarkId: string) => {
        return deleteSiteRecceRemark(clientInstallationId, projectInstallationId, siteRecceId, remarkId);
    });

    const removeRemark = async (remarkId: string) => {
        const data = await removeRemarkMutation.mutateAsync(remarkId);
        return data;
    };
    return {
        isCancelling: cancelMutation.isLoading, // ✅ Separate loading state
        isCompleting: completeMutation.isLoading, // ✅ Separate loading state
        isAdding: addRemarksMutation.isLoading, // ✅ Separate loading state
        cancelRecce,
        completeRecce,
        addRemarks,
        removeRemark,
    };
};

export default useRemarksUpdateSiteRecce;
